export default class UsuarioAdapter {
  static toApi(usuarioStore) {
    return {
      ...usuarioStore,
      cpf: usuarioStore.cpf ? usuarioStore.cpf.replaceAll(/[.,()/\s-]+/g, '') : '',
    }
  }
}